var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvoice = function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.217 32.833c1.367-1.467 3.45-1.35 4.65.25l1.684 2.25c1.35 1.783 3.533 1.783 4.883 0l1.683-2.25c1.2-1.6 3.284-1.717 4.65-.25 2.967 3.167 5.384 2.117 5.384-2.317V11.733c.016-6.717-1.55-8.4-7.85-8.4H13.7c-6.3 0-7.867 1.683-7.867 8.4V30.5c0 4.45 2.433 5.483 5.383 2.333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 12.917H13.334a1.26 1.26 0 0 1-1.25-1.25c0-.683.567-1.25 1.25-1.25h13.333c.684 0 1.25.567 1.25 1.25a1.26 1.26 0 0 1-1.25 1.25ZM25 19.583H15a1.26 1.26 0 0 1-1.25-1.25c0-.683.567-1.25 1.25-1.25h10c.683 0 1.25.567 1.25 1.25a1.26 1.26 0 0 1-1.25 1.25Z",
    fill: "currentColor"
  })));
};
export default SvgInvoice;